import React, { useState, useEffect } from "react";
import "./HomeVideo.css";
import { Fade } from "react-awesome-reveal";
import AnnualDaySlider from "./AnnualdayImageSlider";

function HomeVideo() {
    const [videos, setVideos] = useState([]);
    const [popupData, setPopupData] = useState(null);
const [loading, setLoading] = useState(true);
    const BASE_URL = "https://kkblossomschool.org/KKBlossomsWebsite/uploads/videos/";
const [loadedVideos, setLoadedVideos] = useState({});
const handleVideoLoaded = (id) => {
    setLoadedVideos((prev) => ({
        ...prev,
        [id]: true,
    }));
};
    // 🔥 Fetch videos from backend
   useEffect(() => {
    setLoading(true);

    fetch("https://kkblossomschool.org/KKBlossomsWebsite/api.php?action=getVideos")
        .then((res) => res.json())
        .then((data) => {
            setVideos(data);
        })
        .catch((err) => {
            console.error("Error fetching videos:", err);
        })
        .finally(() => {
            setLoading(false);
        });
}, []);

    const openPopup = (video) => {
        setPopupData(video);
    };

    const closePopup = () => {
        setPopupData(null);
    };

    const getFadeDirection = (index) => {
        if (index === 0) return "left";
        if (index === 1) return "down";
        return "right";
    };

    // 🔥 Separate Annual Day video
    const annualVideo = videos.find(v =>
        v.title.toLowerCase().includes("annual")
    );

    // 🔥 Remaining videos
    const otherVideos = videos.filter(v =>
        !v.title.toLowerCase().includes("annual")
    );
if (loading) {
  return (
   <div className="awards-loader-wrapper">
        <svg
          role="img"
          aria-label="Loading"
          className="awards-smiley"
          viewBox="0 0 128 128"
        >
          <defs>
            <clipPath id="awards-smiley-eyes">
              <circle
                className="awards-smiley__eye1"
                cx="64"
                cy="64"
                r="8"
                transform="rotate(-40,64,64) translate(0,-56)"
              />
              <circle
                className="awards-smiley__eye2"
                cx="64"
                cy="64"
                r="8"
                transform="rotate(40,64,64) translate(0,-56)"
              />
            </clipPath>

            <linearGradient
              id="awards-smiley-grad"
              x1="0"
              y1="0"
              x2="0"
              y2="1"
            >
              <stop offset="0%" stopColor="#000" />
              <stop offset="100%" stopColor="#fff" />
            </linearGradient>

            <mask id="awards-smiley-mask">
              <rect
                x="0"
                y="0"
                width="128"
                height="128"
                fill="url(#awards-smiley-grad)"
              />
            </mask>
          </defs>

          <g
            strokeLinecap="round"
            strokeWidth="12"
            strokeDasharray="175.93 351.86"
          >
            <g>
              <rect
                fill="hsl(207, 90%, 50%)"
                width="128"
                height="64"
                clipPath="url(#awards-smiley-eyes)"
              />

              <g fill="none" stroke="hsl(198, 83%, 60%)">
                <circle
                  className="awards-smiley__mouth1"
                  cx="64"
                  cy="64"
                  r="56"
                  transform="rotate(180,64,64)"
                />

                <circle
                  className="awards-smiley__mouth2"
                  cx="64"
                  cy="64"
                  r="56"
                />
              </g>
            </g>

            <g mask="url(#awards-smiley-mask)">
              <rect
                fill="hsl(205, 86%, 62%)"
                width="128"
                height="64"
                clipPath="url(#awards-smiley-eyes)"
              />

              <g fill="none" stroke="hsl(197, 94%, 63%)">
                <circle
                  className="awards-smiley__mouth1"
                  cx="64"
                  cy="64"
                  r="56"
                  transform="rotate(180,64,64)"
                />

                <circle
                  className="awards-smiley__mouth2"
                  cx="64"
                  cy="64"
                  r="56"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
  );
}
    return (
        <div className="updates-section">

            {/* Title */}
            <Fade direction="down">
                <h2 className="updates-title">LATEST UPDATES</h2>
            </Fade>

            {/* 🎉 Annual Day Section */}
            {annualVideo && (
                <Fade direction="down">
                    <h2 className="highlight-heading">
                        <span>Annual Day</span> Celebrations
                    </h2>

                    <div style={{ display: "flex", justifyContent: "center", marginBottom: "40px" }}>
                        <video
                            src={BASE_URL + annualVideo.file}
                            controls
                            autoPlay
                            muted
                            loop
                            style={{
                                width: "1000px",
                                height: "500px",
                                borderRadius: "10px",
                                objectFit: "cover"
                            }}
                        />
                    </div>
                </Fade>
            )}

            {/* 🎞️ Slider */}
            <Fade direction="up">
                <AnnualDaySlider />
            </Fade>

            {/* 🇮🇳 Independence Section */}
            <Fade direction="down">
                <h2 className="highlight-heading">
                    <span>Independence Day</span> Celebrations
                </h2>
            </Fade>

            {/* 🎥 Video Grid */}
            <div className="updates-grid">
    {otherVideos.map((video, index) => (
        <Fade key={video.id} direction={getFadeDirection(index)}>
            <div
                className="update-card"
                onClick={() => openPopup(video)}
            >
                <div className="media-wrapper">
                    <div
                        className="video-thumbnail"
                        style={{ position: "relative" }}
                    >
                        {!loadedVideos[video.id] && (
                            <div className="video-loader">
                                <div className="spinner"></div>
                            </div>
                        )}

                        <video
                            muted
                            onLoadedData={() =>
                                handleVideoLoaded(video.id)
                            }
                            style={{
                                width: "100%",
                                height: "220px",
                                objectFit: "cover",
                                borderRadius: "10px",
                                display: loadedVideos[video.id]
                                    ? "block"
                                    : "none",
                            }}
                        >
                            <source
                                src={BASE_URL + video.file}
                                type="video/mp4"
                            />
                        </video>

                        <span className="video-icon">▶</span>
                    </div>

                    <span className="badge-new">NEW</span>
                </div>
            </div>
        </Fade>
    ))}
</div>

            {/* 🎬 Popup */}
            {popupData && (
                <div className="popup-overlay" onClick={closePopup}>
                    <div
                        className="popup-content"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button className="popup-close" onClick={closePopup}>
                            &times;
                        </button>

                        <video
                            controls
                            autoPlay
                            style={{
                                width: "90vw",
                                maxWidth: "900px",
                                maxHeight: "80vh",
                                borderRadius: "10px",
                                background: "#000"
                            }}
                        >
                            <source
                                src={BASE_URL + popupData.file}
                                type="video/mp4"
                            />
                        </video>
                    </div>
                </div>
            )}
        </div>
    );
}

export default HomeVideo;